import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/home/Hero";
import Impact from "../components/home/Impact";
import MediaWall from "../components/home/MediaWall";
import VideoGallery from "../components/home/VideoGallery";
import Destinations from "../components/home/Destinations";
import WhereWeWork from "../components/home/WhereWeWork";
import MatchFinder from "../components/home/MatchFinder";
import Featured from "../components/home/Featured";
import Testimonials from "../components/home/Testimonials";
import Stories from "../components/home/Stories";
import Closing from "../components/home/Closing";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white">
      <Navbar />
      <main>
        <Hero />
        <Impact />
        <MediaWall />
        <Stories />
        <Destinations />
        <WhereWeWork />
        <Featured />
        <Testimonials />
        <MatchFinder />
        <VideoGallery />
        <Closing />
      </main>
      <Footer />
    </div>
  );
}
